import {ValueObject} from '@s-ui/domain'

import {RatingFeatureListValueObject} from './RatingFeatureListValueObject.js'

export class VehicleContentValueObject extends ValueObject {
  #description
  #pros
  #cons
  #rating
  #interiorDescription
  #trunkDescription

  constructor({description, pros, cons, rating, interiorDescription, trunkDescription}) {
    super()
    this.#description = description
    this.#pros = pros
    this.#cons = cons
    this.#rating = rating
    this.#interiorDescription = interiorDescription
    this.#trunkDescription = trunkDescription
  }

  get description() {
    return this.#description
  }

  get pros() {
    return this.#pros
  }

  get cons() {
    return this.#cons
  }

  get rating() {
    return this.#rating.value
  }

  get interiorDescription() {
    return this.#interiorDescription
  }

  get trunkDescription() {
    return this.#trunkDescription
  }

  get value() {
    return {
      description: this.#description,
      pros: this.#pros,
      cons: this.#cons,
      rating: this.#rating.value,
      interiorDescription: this.#interiorDescription,
      trunkDescription: this.#trunkDescription
    }
  }

  static createFromPrimitive({content, interiorContent, trunkContent}) {
    const {description, prosAndCons = {}, rating} = content
    const {description: interiorDescription} = interiorContent || {}
    const {description: trunkDescription} = trunkContent || {}
    const {cons, pros} = prosAndCons
    return new VehicleContentValueObject({
      cons,
      description,
      interiorDescription,
      pros,
      rating: RatingFeatureListValueObject.createFromPrimitives({value: rating}),
      trunkDescription
    })
  }
}
